import { render, staticRenderFns } from "./FaturamentoInfoModal.vue?vue&type=template&id=2ba2503b&scoped=true"
import script from "./FaturamentoInfoModal.vue?vue&type=script&lang=js"
export * from "./FaturamentoInfoModal.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoInfoModal.vue?vue&type=style&index=0&id=2ba2503b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2503b",
  null
  
)

export default component.exports